import React, { Component } from 'react';

class TextArea extends Component {
    renderHelperText = () => {
        if (this.props.helperText !== "") {
            return (
                <div className="form-text">
                    {this.props.helperText}
                </div>
            );
        }
        return null;
    }
    renderErrorText = () => {
        if (this.props.errorText !== "") {
            return (
                <div className="text-danger">{this.props.errorText}</div>
            )
        }
        return null;
    }

    render() {
        const { name, label, value, onChange, required, height } = this.props
        return (
            <div className="form-group">
                <label className="contact_label" htmlFor={name}>{label} {required ? <span className="badge bg-danger">必須</span> : ""}</label>
                <textarea className="form-control" id={name} name={name} style={{ height: height }} value={value} onChange={onChange}>

                </textarea>
                {this.renderHelperText()}
                {this.renderErrorText()}
            </div>
        );
    }
}

export default TextArea;